const white = '#fffceb';
const black = '#351e38';
const blue = '#2d5dd7';
export default {
  googleFont: 'https://fonts.googleapis.com/css?family=Gloria+Hallelujah',
  fonts: {
    body: '"Gloria Hallelujah", cursive'
  },
  colors: {
    text: black,
    background: white,
    primary: blue
  }
};